export const dashboardData = {
  admin: {
    bips: {
      data: [
        {
          id: 1,
          type_of_assessment: 1,
          doctor_id: 1,
          doctor: {
            id: 1,
            full_name: 'superadmin admin',
            avatar:
              'https://abatherapy.malcolmcordova.com/backend-api-aba/storage/app/public/staffs/QJCztYlLW8oU6IwCgatrtkH4UgeKpIcYoyfVo62Y.webp',
          },
          patient_id: 'test1',
          background_information: 'test',
          previus_treatment_and_result: 'test',
          current_treatment_and_progress: 'test',
          education_status: 'test',
          phisical_and_medical_status: 'test',
          assestment_conducted: 'test',
          strengths: 'actualizado',
          weakneses: 'actualizadoss',
          documents_reviewed: [
            {
              document_title: 'test',
              document_status: 'yes',
            },
          ],
          maladaptives: [
            {
              baseline_date: '2024-07-12T04:00:00.000Z',
              baseline_level: '24',
              current_intensity: 23,
              initial_interesting: 12,
              maladaptive_behavior: 'test',
              topografical_definition: 'testdsd teslts asd',
            },
          ],
          assestment_conducted_options: [
            {
              assestment_title: 'test',
              assestment_status: 'pending',
            },
          ],
          assestmentEvaluationSettings: [
            {
              index: 1,
              other: 'dasdas',
              tangible: 'Tangible',
              activities: 'asdds',
            },
            {
              index: 2,
              other: 'dads',
              tangible: 'Oootro',
              activities: 'dasdsa',
            },
          ],
          prevalent_setting_event_and_atecedents: [
            {
              behavior: 'test',
              hypothesized_functions: 'test',
              prevalent_setting_event_and_atecedent: 'testsd',
            },
          ],
          interventions: [
            {
              index: 1,
              nombre: 'Nuevo nombre',
              titleIntervention: 'newd',
              descriptionIntervention:
                'ape from the demand or task. Regardless of how long Client engages in these behaviors caregivers will continue to present the',
            },
            {
              index: 2,
              nombre: 'Nuevo nombre',
              titleIntervention: 'dasdas',
              descriptionIntervention:
                'As some of her behaviors are reinforced by escape from demands, extinction will be utilized to eliminate escape after the mentioned maladaptive behaviors. Client will be given a direction to complete a task, if maladaptive behaviors occur, then physical guida',
            },
          ],
          goal_stos: null,
          goal_ltos: null,
          hypothesis_based_intervention: 'ads',
          tangibles: [
            {
              index: 1,
              manager_strategies: 'Access to Tangibles Activities',
              replacement_skills: 'Access to Tangibles Activities',
              preventive_strategies: 'Access to Tangibles Activities',
            },
            {
              index: 2,
              manager_strategies: 'Access to Tangibles Activities',
              replacement_skills: 'Access to Tangibles Activities',
              preventive_strategies: 'Access to Tangibles Activities1',
            },
          ],
          attention: [
            {
              index: 1,
              manager_strategies_a: 'Access to Attention Activities',
              replacement_skills_a: 'Access to Attention Activities',
              preventive_strategies_a: 'Access to Attention Activities',
            },
            {
              index: 2,
              manager_strategies_a: 'Access to Attention Activities',
              replacement_skills_a: 'Access to Attention Activities',
              preventive_strategies_a: 'Access to Attention Activities1',
            },
          ],
          escape: [
            {
              index: 1,
              manager_strategies_e: 'Access to Escape Activities',
              replacement_skills_e: 'Access to Escape Activities',
              preventive_strategies_e: 'Access to Escape Activities',
            },
            {
              index: 2,
              manager_strategies_e: 'Access to Escape Activities',
              replacement_skills_e: 'Access to Escape Activities',
              preventive_strategies_e: 'Access to Escape Activities1',
            },
          ],
          sensory: [
            {
              index: 1,
              manager_strategies_s: 'Access to Sensory Activities',
              replacement_skills_s: 'Access to Sensory Activities',
              preventive_strategies_s: 'Access to Sensory Activities',
            },
            {
              index: 2,
              manager_strategies_s: 'Access to Sensory Activities',
              replacement_skills_s: 'Access to Sensory Activities',
              preventive_strategies_s: 'Access to Sensory Activities1',
            },
          ],
          phiysical_and_medical: 'sadasd',
          phiysical_and_medical_status: [
            {
              dose: 'das das',
              nombre: 'Nuevo nombre',
              reason: 'dsadasd \ndasdsa',
              frecuency: 'dasdasdas',
              medication: 'Medicamento',
              preescribing_physician: 'dsadas',
            },
            {
              dose: '21',
              index: 2,
              nombre: 'Nuevo nombre',
              reason: 'oreodaads',
              frecuency: 'oreo',
              medication: 'oreo',
              preescribing_physician: 'oreo',
            },
          ],
          reduction_goal: [
            {
              id: 1,
              maladaptive: 'test',
              current_status: 'test',
              patient_id: 'test1',
              client_id: 1,
              bip_id: 1,
              goalstos:
                '[{"sto": "test", "nombre": "Nuevo nombre", "date_sto": "2024-07-12T04:00:00.000Z", "status_sto": "inprogress", "maladaptive": "test", "end_date_sto": "2024-09-18T04:00:00.000Z", "decription_sto": "test", "status_sto_edit": "inprogress"}]',
              goalltos:
                '[{"lto": "test", "nombre": "Nuevo nombre", "date_lto": "2024-07-12T04:00:00.000Z", "status_lto": "initiated", "end_date_lto": "2024-09-11T04:00:00.000Z", "decription_lto": "test", "initial_date_lto": "2024-09-03T04:00:00.000Z"}]',
              created_at: '2024-07-12T19:54:29.000000Z',
              updated_at: '2024-09-02T19:04:47.000000Z',
              deleted_at: null,
            },
          ],
          sustitution_goal: [
            {
              id: 1,
              goal: 'test',
              current_status: 'test',
              description: 'test',
              patient_id: 'test1',
              client_id: null,
              bip_id: 1,
              goalstos:
                '[{"index": 1, "target": "45", "sustitution_sto": "1", "sustitution_date_sto": "2024-09-02T04:00:00.000Z", "sustitution_status_sto": "inprogress", "end_sustitution_date_sto": "2024-09-03T04:00:00.000Z", "sustitution_decription_sto": "dasdas", "sustitution_status_sto_edit": "inprogress"}]',
              goalltos:
                '[{"sustitution_lto": "test", "sustitution_date_lto": "2024-07-12T04:00:00.000Z", "sustitution_status_lto": "inprogress", "sustitution_decription_lto": "test"}]',
              created_at: '2024-07-12T19:55:00.000000Z',
              updated_at: '2024-09-02T19:29:27.000000Z',
              deleted_at: null,
            },
          ],
          family_envolment: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              caregivers_training_goals:
                '[{"criteria": "asd", "end_date": "2024-07-31T04:00:00.000Z", "initiation": "2024-07-14T04:00:00.000Z", "caregiver_goal": "adidas", "current_status": "new", "outcome_measure": "dsasda"}, {"index": 2, "criteria": "44ds", "end_date": "2024-09-10T04:00:00.000Z", "initiation": "2024-09-02T04:00:00.000Z", "caregiver_goal": "otro", "current_status": "new", "outcome_measure": "rted"}]',
              created_at: '2024-07-12T20:09:18.000000Z',
              updated_at: '2024-09-02T14:09:27.000000Z',
              deleted_at: null,
            },
          ],
          monitoring_evalutating: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              treatment_fidelity: null,
              rbt_training_goals:
                '[{"lto": "RBT will independently demonstrate appropriate data collection, near 100% of opportunities, across two consecutive observations.", "date": "2024-07-12T04:00:00.000Z", "nombre": "Nuevo nombre", "status": "inprogress", "end_date": "2024-09-10T04:00:00.000Z"}]',
              created_at: '2024-07-12T20:09:32.000000Z',
              updated_at: '2024-09-02T19:49:50.000000Z',
              deleted_at: null,
            },
          ],
          generalization_training: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              discharge_plan: 'test',
              transition_fading_plans:
                '[{"phase": "test", "description": "test"}]',
              created_at: '2024-07-12T20:09:46.000000Z',
              updated_at: '2024-07-12T20:09:46.000000Z',
              deleted_at: null,
            },
          ],
          crisis_plan: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              crisis_description: 'test',
              crisis_note: 'test',
              caregiver_requirements_for_prevention_of_crisis: 'test',
              risk_factors: '[{"do_not_apply": true}]',
              suicidalities: '[{"not_present": true}]',
              homicidalities: '[{"not_present_homicidality": true}]',
              created_at: '2024-07-12T20:10:09.000000Z',
              updated_at: '2024-07-12T20:10:09.000000Z',
              deleted_at: null,
            },
          ],
          de_escalation_technique: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              description: null,
              service_recomendation: null,
              recomendation_lists:
                '[{"cpt": "test", "location": "In Home/School/Community", "num_units": 23, "breakdown_per_week": "test", "description_service": "test"}]',
              created_at: '2024-07-12T20:10:25.000000Z',
              updated_at: '2024-07-12T20:10:25.000000Z',
              deleted_at: null,
            },
          ],
          consent_to_treatment: [
            {
              id: 1,
              bip_id: 1,
              patient_id: 'test1',
              client_id: 1,
              analyst_signature:
                'signatures/ai9wi9HbctxfFlto2mhLJDe4ohWCm1G6iAUlR4T0.jpg',
              analyst_signature_date: '2024-07-12 09:00:00',
              parent_guardian_signature:
                'signatures/HtqGrbQAH5gKHJlzIL239wAIGeyLLxuIjWXdFGcj.jpg',
              parent_guardian_signature_date: '2024-07-12 09:00:00',
              created_at: '2024-07-12T20:10:56.000000Z',
              updated_at: '2024-07-12T20:10:56.000000Z',
              deleted_at: null,
            },
          ],
          created_at: '2024-07-12',
        },
        {
          id: 2,
          type_of_assessment: 2,
          doctor_id: 13,
          doctor: {
            id: 13,
            full_name: 'Allan Hernandez',
            avatar:
              'https://abatherapy.malcolmcordova.com/backend-api-aba/storage/app/public/staffs/EUfW96yMrT9fAZeMmV2AgstUT6sszCtiw5TdLBnK.jpg',
          },
          patient_id: '985590391',
          background_information:
            '-Elnathan is a 6-year old male who has a diagnosis of Autism Spectrum disorder. He lives with his mother, father and 4-year-old brother. He was born in Ethiopia and came to the USA in 2019. In the home the primary language is Amharic, however Elnathan’s’ father speaks English and states that Elnathan understands both languages. He was referred for ABA therapy by Dr. Heather Pittman in 6/19/2023 due to challenging behaviors that interfere with his daily functioning, learning from others and prevent full integration in school/community/family life. An ADOS test was conducted on April 2023 at Golisano Children’s Hospital, results show moderate to severe signs of autism spectrum related symptoms. Elnathan has never received ABA therapy before. \n-Elnathan is able to communicate mostly using one-word mands and gestures, however, needs to increase his verbal repertoire as he will often engage in maladaptive behaviors when he is unable to communicate his needs. Elnathan’s father reports that when they moved from Africa to the US in 2019, Elnathan did not have any speech impediments, however noticed regressions in speech and language after the move and during the pandemic. Elnathan was born full term with no complications and met all his millstones according to his father. His father’s biggest concerns are his deficits in communicating his wants and needs and decreasing maladaptive behaviors of physical aggression, elopement and noncompliance that will impede his daily functioning in society.  Elnathan’s father would like to have services rendered in school due to the increased frequency of maladaptive behaviors reported at school compared to the home, not much at home.  \n-Furthermore, Elnathan exhibits deficits with his tolerance skills, as his father mentions he has limited interest, and will often more from one activity to the next whether it is preferred or not. Additionally, he shares that Elnathan has restrictive behaviors in the form of having rigid routines the whole family has to follow, such as only being able to ride his mother or fathers car, or if the father is off of work still has to continue his work routine of leaving the home at the same time, otherwise Elnathan escalates to more severe maladaptive and that will set the mood for the whole day. \n-Teacher reported that client in the classroom has difficulty remaining on tasks, resists instructions, darts away from tasks, climbs on classroom tables, throws objects such as inflatable chairs. Teacher also reported Elnathan spits on her face, and pushes/shoves peers due to fixation with toy cars and refusal to give up items.',
          previus_treatment_and_result:
            'Elnathan has not previously received ABA therapy.',
          current_treatment_and_progress:
            '- A new behavioral assessment and behavior plan was completed at this time. Age-appropriate replacement objectives have been developed.\n- Current treatment and progress update 3/2024: During this period Elnathan met the mastery on  STO 3 for climbing, for the rest of reduction behavior goals he continues working on STO 1: Physical Aggression, Spitting, Elopement,  Non-Compliance, Object Fixation and Throwing Objects. Regarding acquisition behavior goals Elnathan met the mastery on STO 1 for Follow instructions , Listener responding, Tolerate changes in routine, Give up toy within 3 seconds of Sd and Group goal; he  is also currently working on STO 2 for Manding, on STO 1 for Request a break, Intraverbal training, Tolerates “No” responses, Appropriate protesting , Appropriately requests other’s attention , Delay reinforcer and Sharing',
          education_status:
            '-He was attending First grade at Allan Park Elementary School for school year 23-24. ESE classroom with an active IEP. However, he recently changed schools to Edgewood academy in the beginning of September 2023.  \n- Update 3-2024: ST 30 min school only, recently referred to ST/OT outside of school but parents are still in the process of obtaining those.',
          phisical_and_medical_status:
            '-Elnathan is diagnosed with Autism spectrum disorder, ADHD and sensory processing difficulty. No allergies or dietary restrictions have been reported at this time. Elnathan’s father reports he is not a picky eater and will often choose healthy foods over sugary choices, likely due to his upbringing in Africa where it was not a prominent food group. (no medications)',
          assestment_conducted:
            'A functional behavioral assessment was conducted by BCBA to obtain information regarding the probable contexts and functions of Elnathan’s behavior.',
          strengths: 'test',
          weakneses: 'test',
          documents_reviewed: [
            {
              document_title: 'MNL',
              document_status: 'yes',
            },
            {
              document_title: 'Inital Assessment',
              document_status: 'yes',
            },
            {
              document_title: 'Vineland-3',
              document_status: 'yes',
            },
            {
              document_title: 'IEP',
              document_status: 'yes',
            },
            {
              document_title: 'Doctor Referral',
              document_status: 'yes',
            },
            {
              document_title: 'Doctors Notes',
              document_status: 'yes',
            },
            {
              document_title: 'PSYCHOLOGICAL EVALUATION',
              document_status: 'yes',
            },
            {
              document_title: 'Comprehensive Development Assessment (CDE)',
              document_status: 'yes',
            },
            {
              document_title: 'Autism Diagnostice Observation Schedule (ADOS)',
              document_status: 'yes',
            },
          ],
          maladaptives: [
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '15',
              initial_interesting: 5,
              maladaptive_behavior: 'Physical aggression',
              topografical_definition:
                'Defined as any occurrence of using a hand or arm with a closed or open fist to hit/push (making forceful physical contact) with another person (hitting/pushing/shoving) or scratching using nails against another person’s body. (Non-Examples: Giving a high five, Hugging, Common social physical interactions)',
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '35',
              initial_interesting: 10,
              maladaptive_behavior: 'Spitting',
              topografical_definition:
                'Defined as any instance of forcibly expelling saliva or other fluids from the mouth, through the lips, resulting in visible droplets or a stream of fluid exiting the mouth. Including pulling a person’s shirt up and spitting on their person. Typically towards the teacher.',
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '70',
              initial_interesting: 23,
              maladaptive_behavior: 'Elopement',
              topografical_definition:
                "Defined as leaving designated area to be further than 2 feet from the designated area or more than an arm's reach from the adult when in public places. May try to open the door of the classroom. Scored as a frequency if child turns and attempts to run away, getting at least 1 foot out of designated area, even if the behavior is blocked for safety purposes prior to teaching unsafe distances.",
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '50',
              initial_interesting: 2,
              maladaptive_behavior: 'Noncompliance',
              topografical_definition:
                'Defined as any instance of task avoidance such as Elnathan stating “no” when presented with a task demand or instruction, ignoring an instruction for 15 consecutive seconds or longer, and or starting but not completing given task.',
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '150',
              initial_interesting: 4,
              maladaptive_behavior: 'Climbing',
              topografical_definition:
                'Defined as each instance of climbing tables within the classroom that is not part of the assigned activity.',
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '100',
              initial_interesting: 10,
              maladaptive_behavior: 'Object fixation',
              topografical_definition:
                'Defined as persistent and intense visual concentration on a single physical object (typically a toy car), characterized by prolonged and unbroken eye contact with the object for a duration exceeding three minutes, and refusing to give it up to peers/adults.',
            },
            {
              baseline_date: '2024-07-15T04:00:00.000Z',
              baseline_level: '27',
              initial_interesting: 4,
              maladaptive_behavior: 'Throwing objects',
              topografical_definition:
                'Defined as propelling objects at least one foot from their original location by movement of hand or by kicking it (typically includes throwing donut inflatable chairs and other furniture in the classroom)',
            },
          ],
          assestment_conducted_options: [
            {
              assestment_title:
                'Functional assessment interview completed with mother, and both teachers.',
              assestment_status: 'yes',
            },
            {
              assestment_title: 'vineland-3 teacher form',
              assestment_status: 'yes',
            },
            {
              assestment_title: 'Observations',
              assestment_status: 'yes',
            },
            {
              assestment_title: 'Stimulus preference assessment',
              assestment_status: 'yes',
            },
          ],
          assestmentEvaluationSettings: [
            {
              index: 1,
              tangible: 'Bubbles',
              activities: 'Watching TV, tablet games, running around',
              other: 'Going to the park \nSocial attention',
            },
          ],
          prevalent_setting_event_and_atecedents: [
            {
              behavior: 'Physical aggression',
              hypothesized_functions: 'Attention, escape, tangible',
              prevalent_setting_event_and_atecedent:
                "This behavior may be displayed when any demand given is sustained or something in the environment changed and he receives new instructions to follow or when access to task/activities was denied or delayed, or when he is told 'no'.",
            },
            {
              behavior: 'Elopement',
              hypothesized_functions: 'Escape',
              prevalent_setting_event_and_atecedent:
                'This behavior is displayed when any demand given is sustained or something in the environment changed and he receives new instructions to follow or when attention is withdrawn',
            },
            {
              behavior: 'Noncompliance',
              hypothesized_functions: 'Attention, tangible, escape',
              prevalent_setting_event_and_atecedent:
                "This behavior occurs when attention is withdrawn or a demand was placed, or when access to task/activities was denied or delayed, or when he is told 'no'.",
            },
          ],
          interventions: [
            {
              index: 1,
              titleIntervention: 'Errorless Teaching',
              descriptionIntervention:
                'Ensures Elnathan always responds correctly. As each skill is taught, Elnathan will be provided with a prompt or cue immediately following an instruction. The immediate prompt prevents any chance for incorrect responses. Prompts will be systematically removed until Elnathan is able to respond correctly on his own.',
            },
            {
              index: 2,
              titleIntervention: 'Escape independent response delivery',
              descriptionIntervention:
                'Since one of the main functions of Elnathan maladaptive behaviors is escape, caregivers should provide consumer with frequent breaks during non-preferred tasks/activities. This will reduce the likelihood that he will engage in the maladaptive behavior as a means to escape. The breaks should be scheduled in accordance with his current ability to remain on that task/activity without any incident of a maladaptive behavior. For example, if he is typically able to concentrate on tasks for 3 minutes and after that interval, he engages in incidents of problem behaviors then the break should be scheduled approximately every 2 minutes and increased as he is able to remain on task.',
            },
            {
              index: 3,
              titleIntervention: 'Attention independent response delivery',
              descriptionIntervention:
                'Caregivers should provide attention to Elnathan every 20 min that he is at home (Fixed-time 20 minutes). At the end of each interval, caregiver will approach Elnathan and provide attention by engaging in a short conversation with him for about 1/2 minute and providing praise if he is engaging in an alternative behavior. If at the end of the 20 minutes interval he engaged in a maladaptive behavior, attention will not be provided until 5 minutes have occurred without the maladaptive behaviors.',
            },
            {
              index: 4,
              titleIntervention:
                'Thinning Response independent attention delivery:',
              descriptionIntervention:
                'NCR will be thinned as consumer’s behaviors begin to show a decreased trend. We will thin the schedule from 20 minutes to 30 minutes, 40 minutes and so on.',
            },
          ],
          goal_stos: null,
          goal_ltos: null,
          hypothesis_based_intervention:
            'The following hypothesis-based interventions and instructional practices will be initiated to address the different patterns of behavior/response classes.  These strategies have been selected because they are directly linked to the functions of Elnathan’s behavior and they are the least intrusive and most effective options available that will work within the environments in which he participates.',
          tangibles: [
            {
              index: 1,
              preventive_strategies:
                'Anticipate transitions and tell Elnathan what it is going to happen next, giving him time to reorganize himself. \n\nUse a timer to indicate the end of an activity and the beginning of the new task. \n\nWhen possible, only start activities when there is time to complete them\nLet Elnathan know when the activities will be available again (e.g., on a picture schedule)\nEncourage Elnathan to engage in another activity while waiting\nRemind Elnathan of positive upcoming activities, using “if-then” statements\n\nRemove highly preferred items that Elnathan cannot have from sight or reach– or keep them out of the house altogether',
              replacement_skills:
                'Delay of Reinforcement (wait for tangibles) \n\nAccepting "no"',
              manager_strategies:
                'Positive Behaviors: \nIf Elnathan waits for desired items/activities: Praise him and give the access to the tangible once the designed time has passed. \nIf Elnathan Requests tangibles appropriately, using his words, instead of problem behaviors then praise him and honor his request giving him the desired item/activity, if available.  \n\nMaladaptive behaviors:\nIf Elnathan engages in problem behavior to have access to tangibles, do not allow him to access the item, once he is calm for three seconds; redirect him to use the appropriate request for tangible. \n\nIf Elnathan engages in problem behaviors block the behavior (less than 15 sec), do not allow him to access the item, once he is calm for three seconds; redirect him to use the appropriate request for tangible.',
            },
          ],
          attention: [
            {
              index: 1,
              preventive_strategies_a:
                'Provide attention to Elnathan every 10 minutes \n\nAt the end of each 10-minute interval, caregiver should approach him and provide attention by engaging in a short conversation with him\n\nLet Elnathan know when attention will be available and unavailable by for example, explaining to him when you are going to be in a phone call and how attention will be available immediately after that. \n\nProvide alternative activities or toys, tablet and cards when attention will be withdrawn \n\nRemind Elnathan to request attention with appropriate behavior',
              replacement_skills_a:
                'Teach Elnathan to gain other’s attention appropriately\n\nTeach him to wait for attention',
              manager_strategies_a:
                'Positive Behaviors: \nProvide immediate attention if possible when Elnathan requests attention appropriately using his words.\n\nIf unable to provide attention, let Elnathan know when you will be available\nReward lengthy periods of independent activity with special, attention-rich activities such as playing a game together. \n\nMaladaptive behaviors: \nWithhold or minimize attention for, problem behaviors by minimizing conversation and looking away or blocking any possible harmful behavior.\n\nIf necessary, remove yourself or Elnathan to another room to prevent interaction and escalation.\n\nIf Elnathan engages in problem behaviors block the behavior (less than 15 sec), and redirect him to ask for attention appropriately.',
            },
          ],
          escape: [
            {
              index: 1,
              preventive_strategies_e:
                'Simplify, shorten, or clarify tasks, activities, or demands.\n\nEmbed preferred items or activities such as toys or edibles in unpleasant or difficult tasks\n\nRemind Elnathan of more enjoyable activities that will occur following completion of the task/demand using “if-then” statements\n\nBegin demands with tasks that are relatively easy to complete to create behavioral momentum\n\nClearly differentiate choices from directives. \n\nAvoid presenting demands in the presence of a noisy environment\n\nRemind Elnathan when he is allowed to say no and to request breaks or assistance\n\nElnathan’s working materials and environment should periodically change to avoid escape based behaviors by satiation. \n\nTeach Elnathan to develop a plan for completing activities, allowing brief breaks and ordering tasks to make them more manageable',
              replacement_skills_e:
                'Teach Elnathan to say no to a task (e.g., shaking head, “later, please”, “not now”, “No, thanks”)\n\nTeach Elnathan to request a break by using words\n\nTolerate non-preferred tasks\n\nTeach Elnathan to increase time on tasks',
              manager_strategies_e:
                'Positive Behaviors: \nIf Elnathan says no and the task, activity, or demand is not required (e.g., playing a game), respect his decision\nIf Elnathan asks for a break, allow him to exit the activity for (5) minutes while resting in the sofa (not very reinforcing activity)\nIf Elnathan asks for assistance, provide appropriate help\nIf Elnathan follows instructions praise him immediately and allow him to take a break, if needed. \n If Elnathan remains on task, praise him and remind him that he will be able to take a break after a certain period of time (FI) according to the objective he is working at the moment. \n\nMaladaptive behaviors: \nIf Elnathan engages in problem behaviors do not allow him to leave the demand until he completes at least part of the task.\nWithhold access to enjoyable activities until the task, activity, or demand has been completed.\n\nIf Elnathan engages problem behaviors, block the behavior (less than 15 sec), and redirect him to complete at least part of the activity or to request a break.',
            },
          ],
          sensory: null,
          phiysical_and_medical:
            'Elnathan is diagnosed with Autism Spectrum Disorder, ADHD, and sensory processing difficulty. He has no known allergies or dietary restrictions at this time. According to his father, Elnathan is not a picky eater and often prefers healthy foods over sugary options, which is likely influenced by his upbringing in Africa, where sugary foods were not a significant part of the diet. He is not currently taking any medications.',
          phiysical_and_medical_status: [],
          reduction_goal: [
            {
              id: 2,
              maladaptive: 'Physical aggression',
              current_status: '15 incidents per week',
              patient_id: '985590391',
              client_id: 5,
              bip_id: 2,
              goalstos:
                '[{"index":1,"maladaptive":"Physical aggression","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-03-16T04:00:00.000Z","decription_sto":"client will reduce aggression from 15 to 10 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Physical aggression","sto":"STO #2","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-03-17T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce aggression from 10 to 5 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Physical aggression","sto":"STO #3","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce aggression from 5 to 0 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":1,"lto":"LTO","decription_lto":"client will maintain aggression near 0 incidents per week for 3 consecutive months."}]',
              created_at: '2024-07-15T17:39:11.000000Z',
              updated_at: '2024-09-14T17:27:59.000000Z',
              deleted_at: null,
            },
            {
              id: 3,
              maladaptive: 'Spitting',
              current_status: 'Average of 5 incidents per week',
              patient_id: '985590391',
              client_id: 5,
              bip_id: 2,
              goalstos:
                '[{"index":1,"maladaptive":"Spitting","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-01-27T05:00:00.000Z","decription_sto":"client will reduce spitting from 35 to 25 incidents per week for four consecutive weeks"},{"index":2,"maladaptive":"Spitting","sto":"STO #2","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-01-28T05:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce  spitting from 25 to 15 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Spitting","sto":"STO #3","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce  spitting from 15 to 10 incidents per week for four consecutive weeks."},{"index":4,"maladaptive":"Spitting","sto":"STO #4","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce  spitting from 10 to 5 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":1,"lto":"LTO","decription_lto":"client will maintain  spitting near 0  incidents per week for 3 consecutive months."}]',
              created_at: '2024-07-23T02:01:25.000000Z',
              updated_at: '2024-09-14T17:30:19.000000Z',
              deleted_at: null,
            },
            {
              id: 5,
              maladaptive: 'Elopement',
              current_status: 'Average of 5 incidents per week AUG 2024',
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"maladaptive":"Elopement","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-08-10T04:00:00.000Z","decription_sto":"client will reduce elopement from 14 to 10 incidents per week for four consecutive weeks."},{"index":2,"maladaptive":"Elopement","sto":"STO #2","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-08-11T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce elopement from 10 to 5 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Elopement","sto":"STO #3","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce elopement from 5 to 0 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":1,"lto":"LTO","decription_lto":"client will maintain elopement near 0 incidents per week for 3 consecutive months."}]',
              created_at: '2024-09-09T23:38:55.000000Z',
              updated_at: '2024-09-14T17:32:36.000000Z',
              deleted_at: null,
            },
            {
              id: 6,
              maladaptive: 'Noncompliance',
              current_status: 'Average of 42 incidents per week  AUG 2024',
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":2,"maladaptive":"Noncompliance","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-03-23T04:00:00.000Z","decription_sto":"client will reduce noncompliance from 50 to 40 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Noncompliance","sto":"STO #2","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-03-24T04:00:00.000Z","end_date_sto":"2024-07-27T04:00:00.000Z","decription_sto":"client will reduce noncompliance from 40 to 30 incidents per week for four consecutive weeks."},{"index":4,"maladaptive":"Noncompliance","sto":"STO #3","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-07-28T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce noncompliance from 30 to 20 incidents per week for four consecutive weeks."},{"index":5,"maladaptive":"Noncompliance","sto":"STO #4","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce noncompliance from 20 to 15 incidents per week for four consecutive weeks."},{"index":6,"maladaptive":"Noncompliance","sto":"STO #5","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce noncompliance from 15 to 10 incidents per week for four consecutive weeks."},{"index":7,"maladaptive":"Noncompliance","sto":"STO #6","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce noncompliance from 10 to 5 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":2,"lto":"LTO","decription_lto":"client will maintain noncompliance 5 or below incidents per week for 3 consecutive months."}]',
              created_at: '2024-09-14T17:35:13.000000Z',
              updated_at: '2024-09-14T18:49:05.000000Z',
              deleted_at: null,
            },
            {
              id: 7,
              maladaptive: 'Climbing',
              current_status: 'Average of 2 incidents per week  AUG 2024',
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"maladaptive":"Climbing","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2023-12-02T05:00:00.000Z","decription_sto":"client will reduce climbing from 150 to 130 incidents per week for four consecutive weeks."},{"index":2,"maladaptive":"Climbing","sto":"STO #2","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-12-03T05:00:00.000Z","end_date_sto":"2023-12-30T05:00:00.000Z","decription_sto":"client will reduce climbing from 130 to 110 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Climbing","sto":"STO #3","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-01-01T05:00:00.000Z","end_date_sto":"2024-02-03T05:00:00.000Z","decription_sto":"client will reduce climbing from 110 to 90 incidents per week for four consecutive weeks."},{"index":4,"maladaptive":"Climbing","sto":"STO #4","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-02-04T05:00:00.000Z","end_date_sto":"2024-03-02T05:00:00.000Z","decription_sto":"client will reduce climbing from 90 to 70 incidents per week for four consecutive weeks."},{"index":5,"maladaptive":"Climbing","sto":"STO #5","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-03-03T05:00:00.000Z","end_date_sto":"2024-03-23T04:00:00.000Z","decription_sto":"client will reduce climbing from 70 to 50 incidents per week for four consecutive weeks."},{"index":6,"maladaptive":"Climbing","sto":"STO #6","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-03-24T04:00:00.000Z","end_date_sto":"2024-04-20T04:00:00.000Z","decription_sto":"client will reduce climbing from 50 to 30 incidents per week for four consecutive weeks."},{"index":7,"maladaptive":"Climbing","sto":"STO #7","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-04-21T04:00:00.000Z","end_date_sto":"2024-05-11T04:00:00.000Z","decription_sto":"client will reduce climbing from 30 to 20 incidents per week for four consecutive weeks."},{"index":8,"maladaptive":"Climbing","sto":"STO #8","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-05-12T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce climbing from 20 to 10 incidents per week for four consecutive weeks."},{"index":9,"maladaptive":"Climbing","sto":"STO #9","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce climbing from 10 to 5 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":1,"lto":"LTO","decription_lto":"client will maintain climbing near 0 incidents per week for 3 consecutive months."}]',
              created_at: '2024-09-14T17:39:43.000000Z',
              updated_at: '2024-09-14T17:39:43.000000Z',
              deleted_at: null,
            },
            {
              id: 8,
              maladaptive: 'Object fixation',
              current_status: 'Average of 43 incidents per week AUG 2024',
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":2,"maladaptive":"Object fixation","sto":"STO #1","status_sto":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-07-06T04:00:00.000Z","decription_sto":"client will reduce object fixation from 50 to 40 incidents per week for four consecutive weeks.","nombre":"Nuevo nombre"},{"index":2,"maladaptive":"Object fixation","sto":"STO #2","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-07-07T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce object fixation from 40 to 30 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Object fixation","sto":"STO #3","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce object fixation from 30 to 20 incidents per week for four consecutive weeks."},{"index":4,"maladaptive":"Object fixation","sto":"STO #4","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce object fixation from 20 to 10 incidents per week for four consecutive weeks."},{"index":5,"maladaptive":"Object fixation","sto":"STO #5","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce object fixation from 10 to 5 incidents per week for four consecutive weeks."},{"index":6,"maladaptive":"Object fixation","sto":"STO #6","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce object fixation from 5 to 0 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":1,"lto":"LTO","decription_lto":"client will maintain object fixation near 0 incidents per week for 3 consecutive months."}]',
              created_at: '2024-09-14T17:43:06.000000Z',
              updated_at: '2024-09-14T17:43:06.000000Z',
              deleted_at: null,
            },
            {
              id: 9,
              maladaptive: 'Throwing objects',
              current_status: 'Average of 3 incidents per week AUG 2024',
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[[],{"index":2,"maladaptive":"Throwing objects","sto":"STO #1","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2023-11-01T04:00:00.000Z","end_date_sto":"2024-03-23T04:00:00.000Z","decription_sto":"client will reduce throwing objects from 50 to 40 incidents per week for four consecutive weeks."},{"index":3,"maladaptive":"Throwing objects","sto":"STO #2","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-03-24T04:00:00.000Z","end_date_sto":"2024-04-13T04:00:00.000Z","decription_sto":"client will reduce throwing objects from 40 to 30 incidents per week for four consecutive weeks."},{"index":4,"maladaptive":"Throwing objects","sto":"STO #3","status_sto":"mastered","status_sto_edit":"mastered","initial_date_sto":"2024-04-14T04:00:00.000Z","end_date_sto":"2024-05-11T04:00:00.000Z","decription_sto":"client will reduce throwing objects from 30 to 20 incidents per week for four consecutive weeks."},{"index":5,"maladaptive":"Throwing objects","sto":"STO #4","status_sto":"inprogress","status_sto_edit":"inprogress","initial_date_sto":"2024-05-12T04:00:00.000Z","end_date_sto":null,"decription_sto":"client will reduce throwing objects from 20 to 10 incidents per week for four consecutive weeks."},{"index":6,"maladaptive":"Throwing objects","sto":"STO #5","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce throwing objects from 10 to 5 incidents per week for four consecutive weeks."},{"index":7,"maladaptive":"Throwing objects","sto":"STO #6","status_sto":null,"status_sto_edit":null,"initial_date_sto":null,"end_date_sto":null,"decription_sto":"client will reduce throwing objects from 5 to 0 incidents per week for four consecutive weeks."}]',
              goalltos:
                '[{"index":2,"lto":"LTO","decription_lto":"client will maintain throwing objects near 0 incidents per week for 3 consecutive months."}]',
              created_at: '2024-09-14T18:31:37.000000Z',
              updated_at: '2024-09-14T18:31:37.000000Z',
              deleted_at: null,
            },
          ],
          sustitution_goal: [
            {
              id: 12,
              goal: 'Manding',
              current_status:
                'Average of  68% per week. (In progress LTO) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2023-12-23T05:00:00.000Z","sustitution_decription_sto":"Elnathan will use a carrier phrase (\\u201cI want\\u2026\\u201d) to access preferred items\\/activities with no maladaptive behaviors present in 80% of trials, across 4 consecutive weeks.","nombre":"Nuevo nombre"},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2024-03-12T04:00:00.000Z","end_sustitution_date_sto":"2024-04-12T04:00:00.000Z","sustitution_decription_sto":"Elnathan will use two different of carrier phrases (\\u201cI want\\u2026\\u201d, Can I have\\u2026\\u201d) to access preferred items\\/activities with no maladaptive behaviors present in 80% of trials, across 4 consecutive weeks."},{"index":3,"sustitution_sto":"STO#3","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2024-04-13T04:00:00.000Z","end_sustitution_date_sto":"2024-07-20T04:00:00.000Z","sustitution_decription_sto":"Mands for others to emit 10 different actions needed to enjoy a desired activity (e.g., open to get outside, push when on a swing)  in 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_status_lto":"inprogress","sustitution_date_lto":"2024-07-21T04:00:00.000Z","sustitution_decription_lto":"Elnathan will use a variety of carrier phrases (\\u201cI want\\u2026\\u201d, Can I have\\u2026\\u201d, Can I see.., etc.) to access preferred items\\/activities with no maladaptive behaviors present in 90% of trials, across 4 consecutive weeks."}]',
              created_at: '2024-09-14T20:55:22.000000Z',
              updated_at: '2024-09-16T19:59:09.000000Z',
              deleted_at: null,
            },
            {
              id: 14,
              goal: 'Request a break from non-preferred activity',
              current_status:
                'Average of  65% per week. (In progress STO 2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-07-20T04:00:00.000Z","sustitution_decription_sto":"Elnathan will request a break from non-preferred activity, independently, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-07-21T04:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will request a break from non-preferred activity in 80% of trials, across 4 consecutive weeks."}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain requesting a break from non-preferred activity, independently (no prompts), in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T20:57:14.000000Z',
              updated_at: '2024-09-14T20:57:14.000000Z',
              deleted_at: null,
            },
            {
              id: 16,
              goal: 'Transitions appropriately to non-preferred activities',
              current_status: 'Duplicate of IEP not allowed.',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","sustitution_decription_sto":"Elnathan will transition appropriately to non-preferred activities, independently, in 50% of trials, across 4 consecutive weeks.","nombre":"Nuevo nombre","sustitution_status_sto":"discontinued"},{"index":2,"sustitution_sto":"STO#2","target":null,"sustitution_status_sto":"discontinued","sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will transition appropriately to non-preferred activities in 80% of trials, across 4 consecutive weeks","nombre":"Nuevo nombre"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain transitioning appropriately to non-preferred activities, independently (no prompts), in 90% of trials, 3 consecutive months.","nombre":"Nuevo nombre","sustitution_status_lto":"discontinued"}]',
              created_at: '2024-09-14T21:03:10.000000Z',
              updated_at: '2024-09-14T21:04:54.000000Z',
              deleted_at: null,
            },
            {
              id: 18,
              goal: 'Follow instructions to complete non-preferred tasks',
              current_status:
                'Average of  86% per week. (in progress LTO) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-02-03T05:00:00.000Z","sustitution_decription_sto":"Elnathan will follow instructions to complete non-preferred tasks, with prompts, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2024-02-04T05:00:00.000Z","end_sustitution_date_sto":"2024-07-27T04:00:00.000Z","sustitution_decription_sto":"Elnathan will follow instructions to complete non-preferred tasks, independently, in 80% of trials, across 4 consecutive weeks."}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_status_lto":"inprogress","sustitution_date_lto":"2024-07-28T04:00:00.000Z","sustitution_decription_lto":"Elnathan will maintain following instructions to complete non-preferred tasks, independently (no prompts), in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:08:15.000000Z',
              updated_at: '2024-09-14T21:08:15.000000Z',
              deleted_at: null,
            },
            {
              id: 20,
              goal: 'Listener responding',
              current_status:
                'Average of  56% per week. (in progress STO 2) APR,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-02-03T05:00:00.000Z","sustitution_decription_sto":"selects the correct item from an array of 4, for 20 different objects or pictures (e.g., Show me cat. Touch shoe.) in 80% of trials, across 4 consecutive weeks"},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-02-04T05:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Selects the correct item from a messy array of 6, for 40 different objects or pictures (e.g., Find cat. Touch ball.) in 80% of trials across 4 consecutive weeks."},{"index":3,"sustitution_sto":"STO#3","target":null,"sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Generalizes listener discriminations (LDs) in a messy array of 8, for 3 different examples of 50 items (e.g., the child can find 3 examples of a train) in 80% of trials across 4 consecutive weeks."},{"index":4,"sustitution_sto":"STO#4","target":null,"sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Performs 10 specific motor actions on command (e.g., Show me clapping. Can you hop?) in 80% of trials across 4 consecutive weeks."},{"index":5,"sustitution_sto":"STO#5","target":null,"sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Follows 50 two-component noun-verb and\\/or verb-noun instructions (e.g., Show me the baby sleeping. Push the swing.) in 80% of trials across 4 consecutive weeks."},{"index":6,"sustitution_sto":"STO#6","target":null,"sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Selects the correct item in a book, picture scene, or natural environment when named for 250 items, tested or from an accumulated list of known words in 80% of trials across 4 consecutive weeks.\\nadd more LR goals"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Selects the correct item from a messy array of 6 or more, for 40 different objects or pictures (e.g., Find cat. Touch ball.) in 80% of trials, across 4 consecutive weeks"}]',
              created_at: '2024-09-14T21:11:59.000000Z',
              updated_at: '2024-09-14T21:11:59.000000Z',
              deleted_at: null,
            },
            {
              id: 22,
              goal: 'Intraverbal training',
              current_status:
                'Average of 49% per week. (In progress  STO 1) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2023-11-01T04:00:00.000Z","sustitution_decription_sto":"Provides first name when asked and age when asked in 80% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Completes 5 different fill-in-the-blank phrases (not including songs) (e.g., You eat... You sleep in a... Shoes and...) in 80% of trials, across 4 consecutive weeks"},{"index":3,"sustitution_sto":"STO#3","target":"80","sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Completes 10 different fill-in-the-blank phrases (not including songs) (e.g., You eat... You sleep in a... Shoes and...) in 80% of trials, across 4 consecutive weeks"}]',
              goalltos: '[]',
              created_at: '2024-09-14T21:16:43.000000Z',
              updated_at: '2024-09-14T21:16:43.000000Z',
              deleted_at: null,
            },
            {
              id: 23,
              goal: 'Tolerates “No” responses',
              current_status:
                'Average of  61% per week. (In progress  STO 2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-06-15T04:00:00.000Z","sustitution_decription_sto":"Elnathan will tolerate \\u201cno\\u201d responses, independently, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-06-16T04:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will tolerate \\u201cno\\u201d responses in 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain tolerate \\u201cno\\u201d responses, independently (no prompts), in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:18:43.000000Z',
              updated_at: '2024-09-14T21:18:43.000000Z',
              deleted_at: null,
            },
            {
              id: 24,
              goal: 'Appropriate protesting',
              current_status:
                'Average of  49% per week. (In progress  STO 1) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2023-11-01T04:00:00.000Z","sustitution_decription_sto":"Elnathan will protest appropriately by stating no thank you, with prompts, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will protest appropriately (say \\u201cno thank you\\u201d, \\u201cnot right now\\u201d, \\u201cmay be later\\u201d, independently in 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain protest appropriately, independently (no prompts), in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:20:20.000000Z',
              updated_at: '2024-09-14T21:20:20.000000Z',
              deleted_at: null,
            },
            {
              id: 26,
              goal: 'Appropriately requests other’s attention',
              current_status:
                'Average of  46% per week. (In progress  STO 2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-07-27T04:00:00.000Z","sustitution_decription_sto":"Elnathan will appropriately request other\\u2019s attention, independently, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-07-28T04:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will appropriately request other\\u2019s attention in 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain appropriately requesting other\\u2019s attention, independently (no prompts), in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:22:29.000000Z',
              updated_at: '2024-09-14T21:22:29.000000Z',
              deleted_at: null,
            },
            {
              id: 27,
              goal: 'Delay reinforcer',
              current_status:
                'Average of  82% per week. (In progress  STO 2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO1","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-07-27T04:00:00.000Z","sustitution_decription_sto":"Elnathan will wait for preferred item\\/activity at least 3 minutes, in the absence of challenging behavior, independently at 80% trials for 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO2:","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-07-28T04:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will wait for preferred item\\/activity at least 5 minutes, in the absence of challenging behavior, independently at 80% trials for 4 consecutive weeks."},{"index":3,"sustitution_sto":"STO3","target":"80","sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will wait for preferred item\\/activity at least 10 minutes, in the absence of challenging behavior, independently at 80% trials for 4 consecutive weeks."}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain waiting for preferred item\\/activity at least 15 minutes, independently at 80% trials for 3 consecutive months"}]',
              created_at: '2024-09-14T21:24:12.000000Z',
              updated_at: '2024-09-14T21:24:12.000000Z',
              deleted_at: null,
            },
            {
              id: 28,
              goal: 'Sharing',
              current_status:
                'Average of  88% per week. (In progress  STO 2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-07-27T04:00:00.000Z","sustitution_decription_sto":"Elnathan will share preferred items with a peer for up to 1 minutes, with one peer with no problem behaviors present, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-07-28T04:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan share preferred items with a peer for up to 2 minutes, across 2 different peers with no problem behaviors present 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain share preferred items with a peer for up to 3 minutes, across 3 different peers with no problem behaviors present, in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:26:19.000000Z',
              updated_at: '2024-09-14T21:26:19.000000Z',
              deleted_at: null,
            },
            {
              id: 29,
              goal: 'Turn taking',
              current_status: 'Duplicate of IEP not allowed.',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","sustitution_status_sto":"discontinued","sustitution_status_sto_edit":"discontinued","sustitution_decription_sto":"Elnathan will take turns during an ongoing structured game for up to 2 turns, with no target behaviors present, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":null,"sustitution_status_sto":null,"sustitution_status_sto_edit":null,"sustitution_date_sto":null,"end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will take turns during an ongoing structured game for up to 3 turns, with no target behaviors present 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_status_lto":"discontinued","sustitution_decription_lto":"Elnathan will take turns during an ongoing structured game for up to 4 turns, across 3 different peers with no problem behaviors present, in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:27:21.000000Z',
              updated_at: '2024-09-14T21:27:21.000000Z',
              deleted_at: null,
            },
            {
              id: 30,
              goal: 'Tolerate changes in routine',
              current_status:
                'Average of  78% per week. (In progress LTO) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-02-10T05:00:00.000Z","sustitution_decription_sto":"Elnathan will tolerate contrived changes in his daily routine using visual supports, in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2024-02-11T05:00:00.000Z","end_sustitution_date_sto":"2024-07-10T04:00:00.000Z","sustitution_decription_sto":"Elnathan will tolerate natural changes in his daily routine using visual supports.\\n80% of trials, across 4 consecutive weeks."}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_status_lto":"inprogress","sustitution_date_lto":"2024-07-11T04:00:00.000Z","sustitution_decription_lto":"Elnathan will tolerate contrived changes in his daily routine using, without prompts, in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:29:34.000000Z',
              updated_at: '2024-09-14T21:29:34.000000Z',
              deleted_at: null,
            },
            {
              id: 31,
              goal: 'Give up toy within 3 seconds of Sd.',
              current_status:
                'Average of  79% per week. (In progress STO2) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO#1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-02-24T05:00:00.000Z","sustitution_decription_sto":"Elnathan will Give up toy within 3 seconds of Sd., in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO#2","target":"80","sustitution_status_sto":"inprogress","sustitution_status_sto_edit":"inprogress","sustitution_date_sto":"2024-02-25T05:00:00.000Z","end_sustitution_date_sto":null,"sustitution_decription_sto":"Elnathan will Give up toy within 3 seconds of Sd. 80% of trials, across 4 consecutive weeks"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_decription_lto":"Elnathan will maintain Giving up toy within 3 seconds of Sd., without prompts, in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:31:09.000000Z',
              updated_at: '2024-09-14T21:31:09.000000Z',
              deleted_at: null,
            },
            {
              id: 32,
              goal: 'Group goal',
              current_status:
                'Average of  88% per week. (In progress LTO) AUG,  2024',
              description: null,
              patient_id: '985590391',
              client_id: null,
              bip_id: 2,
              goalstos:
                '[{"index":1,"sustitution_sto":"STO1","target":"50","sustitution_status_sto":"mastered","sustitution_status_sto_edit":"mastered","sustitution_date_sto":"2023-11-01T04:00:00.000Z","end_sustitution_date_sto":"2024-02-24T05:00:00.000Z","sustitution_decription_sto":"Elnathan sits in a small group for 5 minutes without disruptive behavior or attempting to leave the group in 50% of trials, across 4 consecutive weeks."},{"index":2,"sustitution_sto":"STO2","target":"80","sustitution_status_sto":"mastered","sustitution_status_sto_edit":null,"sustitution_date_sto":"2024-02-25T05:00:00.000Z","end_sustitution_date_sto":"2024-06-22T04:00:00.000Z","sustitution_decription_sto":"Elnathan sits in a small group for 5 minutes without disruptive behavior or attempting to leave the group in 80% of trials, across 4 consecutive weeks.","nombre":"Nuevo nombre"}]',
              goalltos:
                '[{"index":1,"sustitution_lto":"LTO","sustitution_status_lto":"inprogress","sustitution_date_lto":"2024-06-23T04:00:00.000Z","sustitution_decription_lto":"Elnathan sits in a small group for 5 minutes without disruptive behavior or attempting to leave the group  in 90% of trials, 3 consecutive months"}]',
              created_at: '2024-09-14T21:33:03.000000Z',
              updated_at: '2024-09-14T21:33:03.000000Z',
              deleted_at: null,
            },
          ],
          family_envolment: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              caregivers_training_goals:
                '[{"index":1,"caregiver_goal":"Parents\\/teachers will identify and utilize at least 3 antecedent strategies for attention, sensory, and access-maintained behavior","outcome_measure":"Monthly fidelity checks in which the\\npercentage of times (across 4 data points) the parent demonstrated concept.","criteria":"90% fidelity","initiation":"2024-08-01T04:00:00.000Z","current_status":"in progress"}]',
              created_at: '2024-07-15T16:59:17.000000Z',
              updated_at: '2024-09-21T21:08:37.000000Z',
              deleted_at: null,
            },
          ],
          monitoring_evalutating: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              treatment_fidelity: null,
              rbt_training_goals:
                '[{"lto": "RBT will independently demonstrate Redirection procedure, near 100% of opportunities, across two consecutive observations.", "date": "2024-07-15T04:00:00.000Z", "status": "initiated"}]',
              created_at: '2024-07-15T17:00:17.000000Z',
              updated_at: '2024-07-26T20:07:38.000000Z',
              deleted_at: null,
            },
          ],
          generalization_training: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              discharge_plan:
                'The desired outcomes for discharge will be refined throughout the treatment process. Transition and discharge planning from a treatment program is included in this plan and specifies details of monitoring and follow-up as is appropriate for Elnathan and the family. Parents, extended family members, community caregivers, and others involved professionals will be consulted as the planning process accelerates with 3-6 months prior to the discharge. A description of roles and responsibilities of all providers and effective dates for behavioral targets that must be achieved prior to discharge will be specified and coordinated with all providers, and family members. Discharge and transition planning will involve a gradual step down in services. \nDischarge often requires 6 months or longer. Discharge Services will be reviewed and evaluated, and discharge planning begun when:\n • Elnathan has achieved treatment goals (0 incidents of challenging behavior and performs correctly on skill acquisition goals); OR \n• Family is interested in discontinuing services, OR\n• Family and provider are not able to reconcile important issues in treatment planning and delivery\nElnathan will be discharged when he has mastered all long-term goals being targeted and no additional skills areas and/or behavioral issues have been identified as a need for targeted treatment goals. Parents will also demonstrate understanding of ABA interventions and teaching/modeling for Elnathan consistently without support from therapist.',
              transition_fading_plans:
                '[{"phase": "1", "description": "All maladaptive will be reduced to 90% from bl, and vineland teacher maladaptive domain scales at 17 or less. Behavior analyst and assistant will reduce services by 25%, for 3 consecutive months."}, {"phase": "2", "description": "Phase 1 sustained and Progress on skill acquisition goals at 80%. vineland (teacher form) score of 80 or more on socialization and communication domains. Behavior analyst and assistant will reduce services by 50%, for 3 consecutive months"}, {"phase": "3", "description": "Phase 2 sustained; skills generalized/maintained 80%. Behavior analyst and assistant will reduce services by 75%, for 3 consecutive months."}, {"phase": "4", "description": "Phase 3 sustained for 3 consecutive months. Behavior analyst will provide 1 hr. per week consultation only model to ensure generalization/maintenance of skills, for 3 consecutive months RBT will be discontinued."}, {"phase": "5", "description": "Phase 4 sustained for 3 consecutive months. Behavior analyst will provide 1 hr. per month consultation only model to ensure generalization/maintenance of skills, for 3 consecutive months. Then all services will be discontinued"}]',
              created_at: '2024-07-15T17:01:32.000000Z',
              updated_at: '2024-07-15T17:01:32.000000Z',
              deleted_at: null,
            },
          ],
          crisis_plan: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              crisis_description: 'crisis description',
              crisis_note: 'crisis note',
              caregiver_requirements_for_prevention_of_crisis: 'caregiver',
              risk_factors: '[{"do_not_apply": true}]',
              suicidalities: '[{"not_present": true}]',
              homicidalities: '[{"not_present_homicidality": true}]',
              created_at: '2024-07-15T17:10:52.000000Z',
              updated_at: '2024-07-15T17:10:52.000000Z',
              deleted_at: null,
            },
          ],
          de_escalation_technique: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              description: null,
              service_recomendation: null,
              recomendation_lists:
                '[{"cpt": "97151", "location": "In Home/School", "num_units": 32, "breakdown_per_week": "8", "description_service": "Assessment"}]',
              created_at: '2024-07-15T17:12:25.000000Z',
              updated_at: '2024-07-15T17:12:25.000000Z',
              deleted_at: null,
            },
          ],
          consent_to_treatment: [
            {
              id: 2,
              bip_id: 2,
              patient_id: '985590391',
              client_id: 5,
              analyst_signature:
                'signatures/CTlwi79NHGbzkvXem0eEmJ01mIRQIX2EX67v4gcL.jpg',
              analyst_signature_date: '2024-07-15 09:00:00',
              parent_guardian_signature:
                'signatures/S5VngLe2Fzk9ZUpKLfqvb8ESy1KV95HuSZGNKUaM.jpg',
              parent_guardian_signature_date: '2024-07-15 09:00:00',
              created_at: '2024-07-15T17:13:04.000000Z',
              updated_at: '2024-07-15T17:13:04.000000Z',
              deleted_at: null,
            },
          ],
          created_at: '2024-07-15',
        },
      ],
    },
    locations: {
      data: [
        {
          id: 1,
          title: 'Pelaez',
          address: '704 Goodlette Frank Rd. N Naples, FL 34102',
          phone1: '888-533-2902',
          phone2: '209-390-1597',
          email: 'pelaezandbeyond@gmail.com',
          city: 'Naples',
          state: 'Florida',
          user_id: null,
          client_id: null,
          zip: '34102',
          telfax: null,
          avatar: null,
          created_at: '2024-02-01 05:32 PM',
        },
        {
          id: 2,
          title: 'FENIX',
          address: '2014 4TH ST Sarasota, Florida 34237',
          phone1: '239-224-9534',
          phone2: '239-790-2601',
          email: 'office@fenixbehavior.com',
          city: 'Sarasota',
          state: 'Florida',
          user_id: null,
          client_id: null,
          zip: '34237',
          telfax: null,
          avatar: null,
          created_at: '2024-02-01 05:33 PM',
        },
        {
          id: 3,
          title: 'ABAOFSWF',
          address: '6660 Estero blvd',
          phone1: '888-872-0459',
          phone2: '2396916482',
          email: 'manager@practice-mgmt.com',
          city: 'fort myers Beach',
          state: 'Florida',
          user_id: null,
          client_id: null,
          zip: '33931',
          telfax: null,
          avatar: null,
          created_at: '2024-02-01 05:35 PM',
        },
        {
          id: 4,
          title: 'Chacao',
          address: 'Chacao',
          phone1: '123456',
          phone2: '456789',
          email: 'abachacao@aba.com',
          city: 'Caracas',
          state: 'Distrito Federal',
          user_id: null,
          client_id: null,
          zip: '1234',
          telfax: '456789',
          avatar:
            'https://abatherapy.malcolmcordova.com/backend-api-aba/storage/app/public/locations/PxUPzBByeO6WDUI8PuwARqmGvhSBUTEEPsCKWptl.jpg',
          created_at: '2024-07-10 11:12 AM',
        },
        {
          id: 5,
          title: 'La Trinidad',
          address: 'La trinidad',
          phone1: '12345',
          phone2: '234566435',
          email: 'abatrinidad@aba.com',
          city: 'La trinidad',
          state: 'Distrito Federal',
          user_id: null,
          client_id: null,
          zip: '1234',
          telfax: null,
          avatar:
            'https://abatherapy.malcolmcordova.com/backend-api-aba/storage/app/public/locations/8LxQFBPmhYPyuPohXdJAMD4GdIQwZShO7na0DUMm.jpg',
          created_at: '2024-07-10 11:18 AM',
        },
        {
          id: 6,
          title: 'TEXAS',
          address: '1705 colonial BLVD\r\nB4',
          phone1: '210-686-2720',
          phone2: '888-391-5328',
          email: 'texasoffice@abaofswf.com',
          city: 'Huston',
          state: 'FL',
          user_id: null,
          client_id: null,
          zip: '33907',
          telfax: '888-391-5328',
          avatar: null,
          created_at: '2024-06-06 11:39 PM',
        },
      ],
    },
    total_bips: 2,
    total_patients: 4,
    total_noteRbts: 23,
    total_noteBcbas: 13,
    total_employees: 14,
    recent_patients: [
      {
        id: 6,
        location_id: 2,
        patient_id: 'TestServer',
        first_name: 'Test Server',
        last_name: 'Test Server',
        email: 'TestServer@testserver.com',
        phone: '1221',
        language: 'TestServer',
        parent_guardian_name: 'TestServer',
        relationship: 'TestServer',
        home_phone: '2121',
        work_phone: '122121',
        school_name: 'TestServer',
        school_number: '122',
        zip: 'mTestServer',
        state: 'FL',
        address: 'TestServer',
        gender: 1,
        birth_date: '2024-09-15 04:00:00',
        age: '10',
        avatar: 'patients/qKCJTj4HoQpvI9LmXGF1mchFuAWU6gbwuRFZkdNr.png',
        city: 'MIami',
        education: 'TestServer',
        profession: 'TestServer',
        schedule: 'TestServer',
        summer_schedule: 'undefined',
        special_note: 'TestServer',
        insurer_id: 2,
        insuranceId: 'TestServer',
        eqhlid: 'TestServerEqid',
        elegibility_date: '2024-09-15 04:00:00',
        pos_covered: '"03 School,12 Home"',
        deductible_individual_I_F: '300/500',
        balance: '2500/5000',
        coinsurance: '20%/20%',
        copayments: '10/10',
        oop: '5000/8000',
        diagnosis_code: 'TestServer',
        status: 'inactive',
        patient_control: 'TestServerpc',
        pa_assessments:
          '"[{\\"pa_assessment\\":\\"TestServerPA\\",\\"pa_assessment_start_date\\":\\"2024-09-15T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-09-30T04:00:00.000Z\\",\\"pa_services\\":\\"TestServerPAS\\",\\"pa_services_start_date\\":\\"2024-09-15T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-09-30T04:00:00.000Z\\",\\"cpt\\":\\"97153\\",\\"n_units\\":200,\\"provider\\":\\"RBT\\"},{\\"pa_assessment\\":\\"\\",\\"pa_assessment_start_date\\":null,\\"pa_assessment_end_date\\":null,\\"pa_services\\":\\"TestServerSPA\\",\\"pa_services_start_date\\":\\"2024-09-15T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-09-30T04:00:00.000Z\\",\\"cpt\\":\\"97151\\",\\"n_units\\":300,\\"provider\\":\\"\\"}]"',
        compayment_per_visit: null,
        insurer_secundary: null,
        welcome: 'waiting',
        consent: 'waiting',
        insurance_card: 'waiting',
        mnl: 'requested',
        referral: 'reviewing',
        ados: 'reviewing',
        iep: 'requested',
        asd_diagnosis: 'reviewing',
        cde: 'requested',
        submitted: 'reviewing',
        eligibility: 'requested',
        interview: 'send',
        rbt_home_id: 9,
        rbt2_school_id: 9,
        bcba_home_id: 4,
        bcba2_school_id: 4,
        clin_director_id: 11,
        telehealth: "'false'",
        pay: "'false'",
        created_at: '2024-09-15T22:51:32.000000Z',
        updated_at: '2024-10-09T20:26:34.000000Z',
        deleted_at: null,
      },
      {
        id: 5,
        location_id: 3,
        patient_id: '985590391',
        first_name: 'Elnathan',
        last_name: 'Abere',
        email: 'muleabere@gmail.com',
        phone: '239-209-8105',
        language: 'English',
        parent_guardian_name: 'MULUGETA ABITEW',
        relationship: 'FATHER',
        home_phone: '239-209-8105',
        work_phone: '239-209-8105',
        school_name: 'Edgewood academy',
        school_number: '(239) 334-6205',
        zip: '33916',
        state: 'Florida',
        address: '3697 WINKLER AV, APT 518, FORT MYERS FL 33916',
        gender: 1,
        birth_date: '2017-06-27 04:00:00',
        age: '7',
        avatar: 'patients/PxQKS7VDy3vmzDXeDZqZScr7y3v7fr7sJu5wjeH0.jpg',
        city: 'FORT MYERS',
        education: '2nd Grade',
        profession: 'null',
        schedule:
          'SCHOOL [transferred to Edgewood academy 9/1/23 teacher wants max hrs) /HOME AFERNOON',
        summer_schedule:
          '4/11/24- M-Th 9am-1pm, classes start June 11 ends July 18 per message from Michelle (JP).',
        special_note: 'undefined',
        insurer_id: 6,
        insuranceId: '985590391',
        eqhlid: 'Equhid?',
        elegibility_date: '2024-06-01 04:00:00',
        pos_covered: '"03 School,12 Home,02 Telehealth"',
        deductible_individual_I_F: '500',
        balance: 'undefined',
        coinsurance: '15%',
        copayments: 'undefined',
        oop: '3000',
        diagnosis_code: 'F84.0',
        status: 'active',
        patient_control: 'EH0391',
        pa_assessments:
          '"[{\\"pa_assessment\\":\\"\\",\\"pa_assessment_start_date\\":null,\\"pa_assessment_end_date\\":null,\\"pa_services\\":\\"4Q3FCQ-01\\",\\"pa_services_start_date\\":\\"2024-04-10T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-10-10T04:00:00.000Z\\",\\"cpt\\":\\"97153\\",\\"n_units\\":3120},{\\"pa_assessment\\":\\"\\",\\"pa_assessment_start_date\\":null,\\"pa_assessment_end_date\\":null,\\"pa_services\\":\\"INS1RR-01\\",\\"pa_services_start_date\\":\\"2024-04-10T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-10-10T04:00:00.000Z\\",\\"cpt\\":\\"97155\\",\\"n_units\\":260,\\"provider\\":null},{\\"pa_assessment\\":\\"\\",\\"pa_assessment_start_date\\":null,\\"pa_assessment_end_date\\":null,\\"pa_services\\":\\"INS1RR-01\\",\\"pa_services_start_date\\":\\"2024-04-10T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-10-10T04:00:00.000Z\\",\\"cpt\\":\\"97156\\",\\"n_units\\":260,\\"provider\\":null}]"',
        compayment_per_visit: null,
        insurer_secundary: null,
        welcome: 'yes',
        consent: 'yes',
        insurance_card: 'yes',
        mnl: 'yes',
        referral: 'yes',
        ados: 'yes',
        iep: 'yes',
        asd_diagnosis: 'yes',
        cde: 'yes',
        submitted: 'yes',
        eligibility: 'yes',
        interview: 'receive',
        rbt_home_id: 9,
        rbt2_school_id: 12,
        bcba_home_id: 8,
        bcba2_school_id: 8,
        clin_director_id: 6,
        telehealth: 'true',
        pay: 'true',
        created_at: '2024-07-15T16:44:12.000000Z',
        updated_at: '2024-09-21T22:25:51.000000Z',
        deleted_at: null,
      },
      {
        id: 2,
        location_id: 4,
        patient_id: 'paciente123',
        first_name: 'paciente',
        last_name: 'prueba',
        email: 'paciente@paciente.com',
        phone: '2344332',
        language: 'paciente',
        parent_guardian_name: 'paciente',
        relationship: 'paciente',
        home_phone: '3243',
        work_phone: '324432',
        school_name: 'paciente',
        school_number: '23144',
        zip: 'paciente',
        state: 'paciente',
        address: 'paciente',
        gender: 2,
        birth_date: '2024-07-14 01:00:00',
        age: '4',
        avatar: 'patients/uzL691VVhK0x08sh6GJWizvOl6UqBJf4IUhMNg8M.jpg',
        city: 'paciente',
        education: 'paciente',
        profession: 'paciente',
        schedule: 'paciente',
        summer_schedule: 'paciente',
        special_note: 'paciente',
        insurer_id: 2,
        insuranceId: 'paciente',
        eqhlid: 'paciente',
        elegibility_date: '2024-07-14 01:00:00',
        pos_covered: '"03 School,12 Home,02 Telehealth,99 Other"',
        deductible_individual_I_F: 'paciente',
        balance: 'paciente',
        coinsurance: 'paciente',
        copayments: 'paciente',
        oop: 'paciente',
        diagnosis_code: 'paciente',
        status: 'incoming',
        patient_control: 'paciente',
        pa_assessments:
          '"[{\\"pa_assessment\\":\\"paciente\\",\\"pa_assessment_start_date\\":\\"2024-07-14T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"pa_services\\":\\"pacientew\\",\\"pa_services_start_date\\":\\"2024-07-13T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"cpt\\":\\"97151\\",\\"n_units\\":233}]"',
        compayment_per_visit: null,
        insurer_secundary: null,
        welcome: 'requested',
        consent: 'waiting',
        insurance_card: 'waiting',
        mnl: 'waiting',
        referral: 'reviewing',
        ados: 'reviewing',
        iep: 'reviewing',
        asd_diagnosis: 'requested',
        cde: 'requested',
        submitted: 'waiting',
        eligibility: 'requested',
        interview: 'receive',
        rbt_home_id: 2,
        rbt2_school_id: 2,
        bcba_home_id: 4,
        bcba2_school_id: 4,
        clin_director_id: 3,
        telehealth: "'false'",
        pay: "'false'",
        created_at: '2024-07-13T22:31:47.000000Z',
        updated_at: '2024-10-09T19:23:53.000000Z',
        deleted_at: null,
      },
      {
        id: 1,
        location_id: 2,
        patient_id: 'test1',
        first_name: 'test',
        last_name: 'test',
        email: 'test@test.com',
        phone: '1234',
        language: 'test',
        parent_guardian_name: 'test',
        relationship: 'test',
        home_phone: '322344',
        work_phone: '4223324',
        school_name: 'test',
        school_number: 'test',
        zip: 'test',
        state: 'test',
        address: 'test',
        gender: 1,
        birth_date: '2024-07-12 01:00:00',
        age: '10',
        avatar: 'patients/uzL691VVhK0x08sh6GJWizvOl6UqBJf4IUhMNg8M.jpg',
        city: 'test',
        education: 'test',
        profession: 'test',
        schedule: 'test',
        summer_schedule: 'test',
        special_note: 'test',
        insurer_id: 1,
        insuranceId: 'test',
        eqhlid: 'test',
        elegibility_date: '2024-07-12 01:00:00',
        pos_covered: '"02 Telehealth"',
        deductible_individual_I_F: 'test',
        balance: 'test',
        coinsurance: 'test',
        copayments: 'test',
        oop: 'test',
        diagnosis_code: 'test',
        status: 'active',
        patient_control: 'test',
        pa_assessments:
          '"[{\\"pa_assessment\\":\\"dsadsa\\",\\"pa_assessment_start_date\\":\\"2024-07-13T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"pa_services\\":\\"dsadsaSS\\",\\"pa_services_start_date\\":\\"2024-07-14T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"cpt\\":\\"97153\\",\\"n_units\\":400},{\\"pa_assessment\\":\\"test\\",\\"pa_assessment_start_date\\":\\"2024-07-12T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"pa_services\\":\\"testServ\\",\\"pa_services_start_date\\":\\"2024-07-12T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"cpt\\":\\"97151\\",\\"n_units\\":200},{\\"pa_assessment\\":\\"paProver\\",\\"pa_assessment_start_date\\":\\"2024-07-25T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"pa_services\\":\\"paProverServ\\",\\"pa_services_start_date\\":\\"2024-07-25T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"cpt\\":\\"97151\\",\\"n_units\\":23,\\"provider\\":\\"BCBA\\"},{\\"pa_assessment\\":\\"dasdas\\",\\"pa_assessment_start_date\\":\\"2024-07-26T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"pa_services\\":\\"dasadsadsa\\",\\"pa_services_start_date\\":\\"2024-07-25T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-07-31T04:00:00.000Z\\",\\"cpt\\":\\"97153\\",\\"n_units\\":32},{\\"pa_assessment\\":\\"dasdas\\",\\"pa_assessment_start_date\\":\\"2024-08-20T04:00:00.000Z\\",\\"pa_assessment_end_date\\":\\"2024-08-31T04:00:00.000Z\\",\\"pa_services\\":\\"dasdsads\\",\\"pa_services_start_date\\":\\"2024-08-20T04:00:00.000Z\\",\\"pa_services_end_date\\":\\"2024-08-30T04:00:00.000Z\\",\\"cpt\\":\\"97153\\",\\"n_units\\":4000}]"',
        compayment_per_visit: null,
        insurer_secundary: null,
        welcome: 'waiting',
        consent: 'requested',
        insurance_card: 'reviewing',
        mnl: 'waiting',
        referral: 'waiting',
        ados: 'waiting',
        iep: 'waiting',
        asd_diagnosis: 'requested',
        cde: 'waiting',
        submitted: 'waiting',
        eligibility: 'requested',
        interview: 'send',
        rbt_home_id: 9,
        rbt2_school_id: 9,
        bcba_home_id: 4,
        bcba2_school_id: 4,
        clin_director_id: 11,
        telehealth: "'false'",
        pay: "'false'",
        created_at: '2024-07-12T19:44:40.000000Z',
        updated_at: '2024-08-21T00:42:28.000000Z',
        deleted_at: null,
      },
    ],
    num_bips_current: 0,
    num_bips_before: 0,
    porcentaje_d: 0,
    num_bips_attention_current: 0,
    num_bips_attention_before: 2,
    porcentaje_da: -100,
    num_patients_current: 0,
    num_patients_before: 1,
    porcentajeDP: -100,
  },
  adminYear: {
    months_name: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    query_patients_by_gender: [
      {
        year: 2024,
        month: 7,
        hombre: '2',
        mujer: '0',
      },
    ],
  },
};
